import React, { useState } from 'react';
import { Button } from 'Components/frameworks/button/Button';
import { COLORS } from 'Components/utils/color/colors';

export const ServiceBlockCTA = ({
  addLabel,
  button,
  dataSelector,
  equipment,
  includedLabel,
  price,
  removeLabel,
  type,
}) => {
  const labelAdd = price ? `${addLabel} +${price}` : addLabel;
  const labelRemove = price ? `${removeLabel} -${price}` : removeLabel;
  const dataSelectorTestID = `${dataSelector}-${type ?? ''}`;

  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    await button.onClick?.();
    setIsLoading(false);
  };

  switch (type) {
    case 'add':
      return (
        <Button
          className="w-full"
          data-cs-override-idd={button?.dataCsOverrideId}
          data-selector={`${equipment.id}-ADD`}
          data-testid={dataSelectorTestID}
          isLoading={isLoading}
          onClick={() => {
            handleClick();
          }}
          size="medium"
        >
          {labelAdd}
        </Button>
      );
    case 'remove':
    case 'edit':
      return (
        <Button
          className="w-full"
          color={COLORS.BLACK}
          colorBg={COLORS.TRANSPARENT}
          colorBorder={COLORS.BLACK}
          data-cs-override-id={button?.dataCsOverrideId}
          data-selector={`${equipment.id}-EDIT`}
          data-testid={`${dataSelector}-${type}`}
          isLoading={isLoading}
          onClick={() => {
            handleClick();
          }}
          size="medium"
        >
          {labelRemove}
        </Button>
      );
    case 'disabled':
      return (
        <Button
          className="w-full"
          data-cs-override-id={button?.dataCsOverrideId}
          data-selector={`${dataSelector}-${type}`}
          data-testid={`${dataSelector}-${type}`}
          isDisabled
          onClick={handleClick}
          size="medium"
        >
          {button?.label || includedLabel}
        </Button>
      );
    case 'full':
      return (
        <Button
          className="w-full"
          data-cs-override-id={button?.dataCsOverrideId}
          data-selector={`${dataSelector}-${type}`}
          data-testid={`${dataSelector}-${type}`}
          isDisabled
          onClick={handleClick}
          size="medium"
        >
          {button?.label || includedLabel}
        </Button>
      );
    default:
      return null;
  }
};
